<p-toast></p-toast>

<p-dialog
  [(visible)]="display"
  [modal]="true"
  [style]="{width: '50vw'}"
  [draggable]="false"
  [resizable]="false"
  (onHide)="display = false">
  <ng-template pTemplate="header">
    <div class="dialog-header" style="padding: 0.5rem; display: flex; align-items: center; justify-content: space-between;">
      <h2 style="font-size: 1.2rem; margin: 0;">Carica Immagini per la scheda</h2>
      <div class="code-badge" style="background-color: #f5f5f5; padding: 0.25rem 0.5rem; border-radius: 4px; margin-left: 1rem;">
        <span class="code-value" style="font-weight: bold; color: #3a6e75;">{{ scheda?.codice }}</span>
      </div>
    </div>
  </ng-template>

  <div class="p-fluid">
    <div *ngIf="isUploading" class="loading-container" style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; display: flex; align-items: center; justify-content: center; background-color: rgba(255,255,255,0.9); z-index: 1000;">
      <ng-lottie [options]="options" ></ng-lottie>
    </div>
    <p-fileUpload
      *ngIf="!isUploading"
      name="files"
      [multiple]="true"
      accept="image/*"
      [maxFileSize]="maxFileSize"
      [auto]="true"
      [customUpload]="true"
      (uploadHandler)="onFileUpload($event)"
      [showUploadButton]="false"
      [showCancelButton]="false"
      (onRemove)="onFileRemove()"
      url="https://www.primefaces.org/cdn/api/upload.php"
      [chooseLabel]="choseLabel"
      chooseIcon="pi pi-image"
      >

      <!--   <ng-template pTemplate="content">
          <ul *ngIf="uploadedFiles.length">
              <li *ngFor="let file of uploadedFiles">
                  {{ file.name }} - {{ file.size }} bytes
              </li>
          </ul>
        </ng-template> -->
    </p-fileUpload>
  </div>

  <ng-template pTemplate="footer">
    <p-button
      icon="pi pi-times"
      label="Annulla"
      (onClick)="display = false"
      styleClass="p-button-text">
    </p-button>
    <p-button
      icon="pi pi-check"
      label="Conferma"
      [disabled]="uploadedFiles.length === 0"
      (onClick)="confermaCaricamento()"
      styleClass="p-button-success">
    </p-button>
  </ng-template>
</p-dialog>
